import { __decorate } from "tslib";
import { Component, Ref, useModule, Vue, Watch } from "@/types";
import { Table } from "@/ui-kit";
import { AddEmployees } from "@/components";
import "./employees.scss";
import { generateFIO, createFIO } from "@/helpers";
let Employees = class Employees extends Vue {
    constructor() {
        super(...arguments);
        this.store = useModule(this.$store);
        this.headerData = [
            { name: "Фото", class: "photo", noSort: true },
            { name: "Табельный номер", class: "staffNumber" },
            { name: "ФИО", class: "surname" },
            { name: "Подразделение", class: "departmentName" },
            { name: "Номер ключа", class: "rfid" },
            { name: "График работы", class: "workScheduleName" },
            { name: "График доступа", class: "accessScheduleName" },
        ];
        this.filter = "dismissDate eq null and "; //не показываем уволенных
    }
    get showDialog() {
        return this.store.dialog.curr?.type === "form";
    }
    removeEmployees(val) {
        if (val?.name === "removeEmployees") {
            this.store.dialog.setDetails({
                itemToConfirm: `${val.data.surname} ${val.data.name}`,
                callback: () => {
                    const firedDate = `${new Date().toISOString().slice(0, 10)}`;
                    const dateFired = {
                        ...val.data,
                        dismissDate: firedDate,
                    };
                    return this.store.employees.edit(dateFired).then((isSuccess) => {
                        if (isSuccess) {
                            this.reload(true);
                        }
                        return isSuccess;
                    });
                },
            });
        }
        if (val?.name === "remove") {
            this.store.dialog.setDetails({
                itemToConfirm: `${val.data.surname} ${val.data.name}`,
            });
        }
    }
    async reload(success) {
        if (success) {
            try {
                await this.table.updatePage();
            }
            catch (e) {
                console.log(e);
            }
        }
    }
    fioHelper(surname = "", name = "", patronymic = "") {
        return createFIO(surname, generateFIO(name), generateFIO(patronymic));
    }
};
__decorate([
    Ref("table")
], Employees.prototype, "table", void 0);
__decorate([
    Watch("store.dialog.curr")
], Employees.prototype, "removeEmployees", null);
Employees = __decorate([
    Component({
        components: { AddEmployees, Table },
    })
], Employees);
export default Employees;
